import api from '@/api/api';
import _ from 'lodash';
import EchoProvider from '@/plugins/socket';

const resource = '/user';

const state = {
    me: null,
    email: null,
    token: null,
    role: '',
    chosen_client: null,
    client_id: null,
    client_list: [],
    user_badges: [],
    badge_loading: false,
    loaded: false,
    modal_inform: null,
    authenticated: null,
    sections: {
        storage: null,
    },
};

const getters = {
    TOKEN: (state) => state.token,

    EMAIL: (state) => state.email,

    AUTH: (state) => state.authenticated,

    ME: (state) => state.me,

    getSectionAccess: (state) => Object.entries(state.sections)
        .map((section) => {
            if (section[1]) return section[0];

            return false;
        })
        .filter(Boolean),

    client_id: (state) => state.client_id,
};

const mutations = {
    USERS_INIT() {
        if (localStorage.getItem('token')) {
            this.commit('SET_TOKEN', localStorage.getItem('token'));
            this.commit('set_authenticated', true);

            const tmpChosenClient = localStorage.getItem('chosen_client');
            if (tmpChosenClient) {
                this.commit('setChoseClient', JSON.parse(tmpChosenClient));
            }
        }
    },

    SET_ME: (state, payload) => {
        state.me = payload;
    },

    SET_ROLE: (state, payload) => {
        state.role = payload;
    },

    SET_TOKEN: (state, payload) => {
        state.token = payload;
        localStorage.setItem('token', payload);
    },

    set_client_list(state, payload) {
        state.client_list = payload;
    },

    setChoseClient(state, newClient) {
        if (_.get(state.chosen_client, 'id') === _.get(newClient, 'id')) return;

        if (state.chosen_client) {
            this.dispatch('unsubscribe_badges', state.chosen_client.id);
        }

        state.chosen_client = newClient;
        localStorage.setItem('chosen_client', JSON.stringify(newClient));
    },

    set_user_badges(state, payload) {
        state.user_badges = payload;
    },

    set_badge_loading(state, payload) {
        state.badge_loading = payload;
    },

    set_loaded: (state, payload) => {
        state.loaded = payload;
    },
    set_modal_inform: (state, payload) => {
        state.modal_inform = payload;
    },

    set_authenticated: (state, payload) => {
        state.authenticated = payload;
    },

    remove_close_client: (state) => {
        state.chosen_client = null;
    },
    set_section_storage: (state, payload) => {
        state.sections.storage = payload;
    },
    set_client_id: (state, payload) => {
        state.client_id = payload;
    },
};

const actions = {

    lc_set_loaded: (context, payload) => {
        context.commit('set_loaded', payload);
    },

    loadClientList(context) {
        api().get(`${context.getters.get_app_section}/users/client_list`)
            .then((resp) => resp.data)
            .then((data) => {
                context.commit('set_client_list', data);
                context.commit('set_loaded', true);
            })
            .catch((error) => {
                context.commit('set_loaded', null);
                console.error('Error:', error);
                console.log('Response:', error.response);
            });
    },

    LOGIN: (context, payload) => api(false).post(`${resource}/login`, JSON.stringify(payload))
        .then((resp) => {
            if (resp.status !== 200) {
                throw new Error('Status is not 200');
            }

            return resp;
        })
        .then((resp) => resp.data)
        .then((data) => {
            if (typeof data.token === 'undefined') {
                throw new Error('Token is undefined');
            }

            return data;
        })
        .then((data) => {
            context.commit('SET_TOKEN', data.token);
            context.commit('set_authenticated', true);

            return data;
        })
        .catch((error) => {
            if (error.response.status === 403 && error.response.data === 'Account is not verified') {
                throw new Error('Account is not verified');
            }

            console.error('Error:', error);
            console.log('Response:', error.response);
        }),

    REGISTER: (context, payload) => api(false).post(`${resource}/register`, JSON.stringify(payload))
        .then((resp) => {
            if (typeof resp.data.token === 'undefined') {
                throw new Error('Token is undefined');
            }

            if (!resp.ok) {
                throw new Error();
            }

            return resp;
        })
        .then((data) => {
            context.commit('SET_TOKEN', data.token);
        })
        .then((resp) => {
            this.$store.dispatch('nt_set_notification', {
                type: 'inform',
                message: 'You\'ve registered.',
            });

            return resp;
        })
        .catch((error) => {
            if (error.response.status === 403 && error.response.data === 'Account is not verified') {
                throw new Error('Account is not verified');
            }

            if (error.response.data[0] === 'Email already exist') {
                throw new Error(error.response.data[0]);
            }

            console.error('Error:', error);
            console.log('Response:', error.response);
        }),

    LOGOUT: (context) => {
        context.commit('SET_TOKEN', null);
        context.commit('set_authenticated', false);

        localStorage.clear();
    },

    get_user_badges(context) {
        context.commit('set_badge_loading', true);

        return api().get(`${context.getters.get_app_section}/users/badges`)
            .then((resp) => {
                const {data} = resp;
                context.commit('set_user_badges', data);

                return resp;
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    throw error;
                }

                console.error('Error:', error);
                console.log('Response:', error.response);
            });
    },

    subscribe_badges({commit, dispatch, rootGetters}, newClient) {
        dispatch('get_user_badges');

        EchoProvider.getConnection().private(`Client.${newClient.id}`)
            .listen(`.${rootGetters.get_app_section}.badges.updated`, (resp) => {
                commit('set_user_badges', resp.badges);
            });
    },

    unsubscribe_badges(context, id) {
        EchoProvider.getConnection().leave(`Client.${id}`);
    },

    setClient(context, payload) {
        context.commit('setChoseClient', payload);
    },
    removeClient({state, commit, dispatch}) {
        if (state.chosen_client !== null) {
            const clientId = state.chosen_client.id;

            dispatch('unsubscribe_badges', clientId);
            commit('remove_close_client');
            localStorage.removeItem('chosen_client');
            return;
        }

        if (state.client_id) {
            dispatch('unsubscribe_badges', state.client_id.id);
            dispatch('subscribe_badges', state.client_id);
        }
    },
    get_user_me({commit, dispatch}) {
        return api().get('/me')
            .then((data) => {
                if (data.status !== 200) {
                    throw new Error();
                }

                const user = data.data;
                commit('SET_ME', user);
                commit('SET_ROLE', user.role);
                commit('set_section_storage', user.section_storage);

                if (user.role === 'client') {
                    commit('set_client_id', {id: user.id});
                }
            })
            .catch(() => {
                dispatch('LOGOUT');
                this.$router.push({path: '/login'});
            });
    },
};

export default {
    state,
    getters,
    mutations,
    actions,
};
